import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Button, Typography } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import { useParams } from 'react-router-dom'
import { useCreateForm } from 'hooks/useCreateForm'
import { Dialog, InputField } from 'components'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const schema = yup.object().shape({
  title: yup.string().required('Esse campo é obrigatório').min(4, 'O título deve ter no mínimo 4 caracters').max(255, 'O título deve ter no máximo 255 caracteres'),
  tag: yup.string().required('Esse campo é obrigatório').min(2, 'A tag deve ter no mínimo 2 caracteres').max(255, 'A tag deve ter no máximo 255 caracteres').matches(/^[^0-9][\w&._]+$/, "A tag não pode começar com números e não pode possuir caracteres especiais ou espaços."),
})

const NewForm = () => {
  const { projectId } = useParams()
  const [open, setOpenDialog] = useState(false)

  const methods = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
    defaultValues: {
      title: '',
      tag: '',
    },
  })

  const {
    handleSubmit,
    formState: { isValid, isDirty, errors },
  } = methods

  const { mutate, isLoading } = useCreateForm(projectId, {
    onSuccess: () => setOpenDialog(false),
    onError: () => console.log('Erro')
  })

  return (
    <>
      <Button
        onClick={() => setOpenDialog(true)}
        variant='contained'
        startIcon={<AddIcon />}
        color='primary'
      >
        Novo Formulário
      </Button>
      <FormProvider {...methods}>
        <Dialog
          title='Novo Formulário'
          contentText='Escolha um nome para o novo Formulário. Essa informação é apenas para visualização e você poderá alterar depois.'
          open={open}
          onCancel={() => setOpenDialog(false)}
          isLoading={isLoading}
          submitDisabled={!isValid || !isDirty}
          onSubmit={handleSubmit((data) => mutate(data))}
        >
          <InputField
            id='title'
            name='title'
            label='Nome do Formulário'
            variant='outlined'
            error={errors?.title}
            required
            fullWidth
            inputProps={{maxLength:255}}
          />
          { errors?.title && <Typography color="error" variant='span'>{errors.title.message}</Typography> }
          <InputField
            id='tag'
            name='tag'
            label='Tag do Formulário'
            variant='outlined'
            error={errors?.tag}
            required
            fullWidth
            inputProps={{maxLength:255}}
          />
          { errors?.tag && <Typography color="error" variant='span'>{errors.tag.message}</Typography> }
          {/* <InputField
            id='type'
            name='type'
            required
            label='Escolha o template do formulário'
            fullWidth
            select
          >
            {templates.map((opt) => (
              <MenuItem key={opt.label} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </InputField> */}
        </Dialog>
      </FormProvider>
    </>
  )
}

NewForm.propTypes = {}

NewForm.defaultProps = {}

export default NewForm
